import React from 'react';
import './App.css';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';

class Cart extends React.Component {
        getCourses() {
        let courses = [];
        
        if (Array.isArray(this.props.data)){
         for(let i =0; i < this.props.data.length; i++){
          courses.push (
              <Card key={i} elevation={1} square={true} >

                <p style={{fontWeight:'bolder', 'paddingTop': '5px' ,'paddingLeft': '15px', 'paddingRight': '15px'}}
                    onClick={()=>{
                        this.props.removeCartCourse({
                            course: this.props.data[i].number,
                        })
                    }}
                >
                    {this.props.data[i].number + ": " + this.props.data[i].name}</p>
                    {this.getSections(this.props.data[i].number, i)}
              </Card>
          )
        }
      }
      else{
        for(const course of Object.keys(this.props.data)){
          courses.push (
            <Card>{this.props.data[course].number}</Card>
          )
        }
      }
    
        return courses;
    }

    getSections(courseIdx, i) {
        let currCourse = this.props.cartCourses[this.props.data[i].number];
        let sectionsArr = []
        
        for(const [key, value] of Object.entries(currCourse)) {
            sectionsArr.push(
                <Card key={key} elevation={8} square={true}>
                    <p style={{'paddingTop': '5px', 'paddingLeft': '15px', 'paddingRight': '15px', color: 'darkblue', 'fontWeight': 'bolder'}}
                        onClick={()=>{
                            this.props.removeCartCourse({
                                course: courseIdx,
                                section: key
                            })
                        }}
                    >
                        {/* <React.Fragment style={{'fontWeight': 'bolder'}}>{this.props.data[i].sections[key].number.replace('_'," ")}</React.Fragment> <br></br> */}
                        {this.props.data[i].sections[key].number.replace('_'," ")}<br></br>
                        {this.props.data[i].sections[key].location} <br></br>
                        {this.stringifyTime(this.props.data[i].sections[key].time)}
                    </p>
                    {this.getSubsections(courseIdx, key, currCourse[key])}
                </Card>
            )
        }

        return sectionsArr;    
    }

    getSubsections(courseIdx, sectIdx, currSection) {
        let subsectionArr = [];

        for(const[key,value] of Object.entries(currSection)) {
            subsectionArr.push(
                <Card key={key}  elevation={8} square={true} style={{'paddingTop': '5px', 'paddingLeft': '15px', 'paddingRight': '15px'}}>
                    <p                     
                        onClick={()=>{
                            this.props.removeCartCourse({
                                course: courseIdx,
                                section: sectIdx,
                                subsection: currSection[key]
                            });
                            console.log(currSection)
                        }}
                    >
                        {currSection[key].number.replace('_', " ")} <br></br>
                        {currSection[key].location} <br></br>
                        {this.stringifyTime(currSection[key].time)}
                    </p>
                </Card>
            )
        }

        return subsectionArr;
    }

    stringifyTime(timeArray) {
        var timeArr = [];
        let arr = Object.entries(timeArray);
        arr.map((t,idx) => {
            timeArr.push(<React.Fragment key={idx}>{t[0].charAt(0).toUpperCase() + t[0].slice(1) + ": " + t[1]} <br></br></React.Fragment>)
        })
        return timeArr;
    }

    render() {
        
        const useStyles = makeStyles({
            root: {
                width: "100%",
                },
                bullet: {
                display: 'inline-block',
                margin: '0 2px',
                transform: 'scale(0.8)',
            },
                title: {
                fontSize: 14,
            },
            pos: {
                marginBottom: 12,
            },
        });

        return(
            <>
                <link
                    rel="stylesheet"
                    href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css"
                    integrity="sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T"
                    crossOrigin="anonymous"
                />

                <Card square={true} elevation={3} className={useStyles.root} style={{'marginBottom': '30px'}}>
                    <CardContent>
                        <h3 style={{fontWeight: 'bold'}}>Cart</h3>
                    </CardContent>
                    {this.getCourses()}
                    <CardActions>
                    <Button size="small" style={{fontWeight: 'bold'}} onClick={()=>this.props.clearCart()}>
                        Clear
                    </Button>
                    </CardActions>
                </Card>
            </>
        );
    }

}

export default Cart;